// Copyright (c) Docugami, Inc. All rights reserved.

import { useComponentUsageMetrics } from "hooks/ComponentUsageMetrics";
import styled from "styled-components";

const FooterContainer = styled.div`
    margin-bottom: 7px;
    box-sizing: border-box;
`

const ViewContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px 28px 0px;
    box-sizing: border-box;
    gap: 10px;
    width: 100%;
    height: 100%;
`

const ContentContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
`

const ContentOverlayContainer = styled.div`
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
`

interface ExplorerViewProps {
    header: JSX.Element | null;
    content: JSX.Element;
    overlays: Array<JSX.Element | null>;
    footer: JSX.Element | null;
    telemetryId: string;
    viewContainerProps?: any;
    className?: string;
}

export const ExplorerView = (props: ExplorerViewProps): JSX.Element => {
    useComponentUsageMetrics(`ExplorerView/${props.telemetryId}`);

    return (
        <ViewContainer {...props.viewContainerProps} className={props.className}>
            {props.header}
            <ContentContainer>
                {props.content}
                {
                    props.overlays.map((element, index) => {
                        if (!element) {
                            return null;
                        }

                        return (
                            <ContentOverlayContainer key={`overlay_${index}`}>
                                {element}
                            </ContentOverlayContainer>
                        )
                    })
                }
            </ContentContainer>
            {
                !!props.footer &&
                <FooterContainer>
                    {props.footer}
                </FooterContainer>
            }
        </ViewContainer>
    );
}
